import { buildModelManager } from "../builder.js";
const DefaultExperimentAnalyticsSelection = {
  __typename: true,
  id: true,
  clicks: true,
  confidenceInterval: true,
  conversionRate: true,
  conversions: true,
  createdAt: true,
  date: true,
  experimentId: true,
  impressions: true,
  isWinner: true,
  shopId: true,
  statisticalSignificance: true,
  updatedAt: true,
  variantId: true
};
const modelApiIdentifier = "experiment_analytics";
const pluralModelApiIdentifier = "experiment_analyticss";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultExperimentAnalyticsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultExperimentAnalyticsSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAnalyticsSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAnalyticsSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAnalyticsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAnalyticsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultExperimentAnalyticsSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createExperimentAnalytics",
    operationReturnType: "CreateExperimentAnalytics",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      experiment_analytics: { required: false, type: "CreateExperimentAnalyticsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExperimentAnalyticsSelection
  },
  {
    type: "action",
    operationName: "bulkCreateExperimentAnalytics",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateExperimentAnalyticsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExperimentAnalyticsSelection
  },
  {
    type: "action",
    operationName: "updateExperimentAnalytics",
    operationReturnType: "UpdateExperimentAnalytics",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      experiment_analytics: { required: false, type: "UpdateExperimentAnalyticsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExperimentAnalyticsSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateExperimentAnalytics",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateExperimentAnalyticsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultExperimentAnalyticsSelection
  },
  {
    type: "action",
    operationName: "deleteExperimentAnalytics",
    operationReturnType: "DeleteExperimentAnalytics",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteExperimentAnalytics",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertExperimentAnalytics",
    operationReturnType: "UpsertExperimentAnalytics",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      experiment_analytics: { required: false, type: "UpsertExperimentAnalyticsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateExperimentAnalyticsResult": { hasReturnType: false },
      "... on UpdateExperimentAnalyticsResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultExperimentAnalyticsSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertExperimentAnalytics",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertExperimentAnalyticsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultExperimentAnalyticsSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "experiment_analyticsGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ExperimentAnalyticsManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultExperimentAnalyticsSelection,
  operations
);
export {
  DefaultExperimentAnalyticsSelection,
  ExperimentAnalyticsManager
};
//# sourceMappingURL=ExperimentAnalytics.js.map
